import React, { useState } from 'react';
import {
    IconButton,
    InputAdornment,
  makeStyles,
  TextField,
  TextFieldProps
} from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const useStyles = makeStyles((theme) => ({
  root:{},
  iconColor:{
      color:theme.palette.divider
  }
}));


const CTextField = (props: TextFieldProps) => {

  const classes = useStyles();
  const [showPassword,setShowPassword] = useState(false)


  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  if (props.type !== "password") return (
    <div className={classes.root}>
        <TextField
            {...props}
        >
            {props.children}
        </TextField>
    </div>
  )


  return (
    <div className={classes.root}>
        <TextField
            {...props}
            type={showPassword ? "text":"password"}
            InputProps={{
                endAdornment:
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <Visibility/> : <VisibilityOff className={classes.iconColor}/>}
                    </IconButton>
                  </InputAdornment>
                
              }}
        >
            {props.children}
        </TextField>
    </div>
  )
}

export default CTextField;
